import {
  faGolfBallTee,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import pluralize from "pluralize";

import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./MoreResults.module.css";

const ref = "more-results";

interface MoreResultsProps extends Partial<CommonProps> {
  count: number;
  distance: number;
}

function useMoreResults(props: MoreResultsProps) {
  const { color, id = createId(ref) } = props;
  const className = clsx(styles[ref], color && styles[color], props.className);

  return {
    className,
    id,
  };
}

function MoreResults(props: MoreResultsProps) {
  const { className, id } = useMoreResults(props);
  const { count, distance } = props;

  return (
    <aside className={className} id={id}>
      <header>
        <h2>Wait, there's more&hellip;</h2>
      </header>

      <p>
        We found {pluralize("more result", count, true)} <br />
        within {pluralize("mile", distance, true)} of your search
      </p>

      <footer>
        <FontAwesomeIcon icon={faMapMarkerAlt} size={"3x"} />
        <FontAwesomeIcon icon={faGolfBallTee} size={"1x"} />
      </footer>
    </aside>
  );
}

export default MoreResults;
export { MoreResults, type MoreResultsProps };
